import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress } from '@mui/material';
import { auth } from '../services/api';

const VerifyEmail: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const token = searchParams.get('token');
                if (!token) {
                    setStatus('error');
                    setMessage('Отсутствует токен подтверждения');
                    return;
                }

                const response = await auth.verifyEmail(token);
                setStatus('success');
                setMessage(response.data.message);
                
                // Перенаправляем на страницу входа через 3 секунды
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } catch (error: any) {
                setStatus('error');
                setMessage(error.response?.data?.message || 'Ошибка при подтверждении email');
            }
        };

        verifyEmail();
    }, [searchParams, navigate]);

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {status === 'loading' && (
                    <>
                        <CircularProgress />
                        <Typography variant="h6" sx={{ mt: 2 }}>
                            Подтверждение email...
                        </Typography>
                    </>
                )}

                {status === 'success' && (
                    <Typography variant="h6" color="success.main">
                        {message}
                    </Typography>
                )}

                {status === 'error' && (
                    <Typography variant="h6" color="error">
                        {message}
                    </Typography>
                )}
            </Box>
        </Container>
    );
};

export default VerifyEmail; 